import $ from 'jquery';
import 'bootstrap-select';
import ScrollMagic from 'scrollmagic';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

class Common {
	constructor() {
		this.controller = new ScrollMagic.Controller();
	}

	init() {
        this.bindEvents();
		this.scrollElementUp();
		this.scrollElementLeft();
		this.scrollElementRight();
	}

	bindEvents() {
		$('#trend-reports .tableContainer').each((index, element) => new SimpleBar(element, {
				autoHide: false
			}));

		//$('#trend-reports .tableContainer').each(element, new SimpleBar(element));

		$('.js-toggle-side-menu').on('click', e => { this.toggleSideMenu(e); });

		$('.js-toggle-filter-menu').on('click', e => { this.toggleFilterMenu(e); });

		$('.js-toggle-category-menu').on('click', e => { this.toggleCategoryMenu(e); });

		$('.video').modaal({
			type: 'video',
			width: 930
		});

		$('select:not(.goog-te-combo)').selectpicker({
			mobile: true,
		});
	}

	scrollElementUp() {
		let revealElements = document.getElementsByClassName('scroll-element-up');

		[...revealElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: 50,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});
	}

	scrollElementLeft() {
		let revealElements = document.getElementsByClassName('scroll-element-left');

		[...revealElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: 50,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});
	}

	scrollElementRight() {
		let revealElements = document.getElementsByClassName('scroll-element-right');

		[...revealElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: 50,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});
	}

	toggleSideMenu(e) {
		const target = $(e.currentTarget);

		$(target).toggleClass('active');

		$('.js-side-menu').slideToggle();
	}

	toggleFilterMenu(e) {
		const target = $(e.currentTarget);

		$(target).toggleClass('active');

		$('.js-filter-menu').slideToggle();
	}

	toggleCategoryMenu(e) {
		const target = $(e.currentTarget);

		$(target).toggleClass('active');

		$('.js-category-menu').slideToggle();
	}
}

export default Common;